module.exports = __webpack_public_path__ + "img/Normal_OVERTEMP.7cba3811.png";